import { Link } from "react-router-dom";
import {
    FeedPostDropDown,
    IncidentLocation,
    PostImagePoll,
    PostLink,
    PostMedia1,
    PostMedia2,
    PostMedia3,
    PostMedia4,
    PostMediaVid,
    PostMedia6,
    PostText,
    PostTextPoll,
    PostUserBlock,
    SocialCount
} from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";
// import { useState } from "react";

import vid from "assets/videos/vi1.mp4";

export type MarkFeedPostProps = CustomComponentProps & {
    isIncident?: boolean;
    text?: string;
    isHashtag?: boolean;
    hashtag?: string;
    place?: string;
    link?: string;
    mediaType?: number;
};

const MarkFeedPost = ({
    isIncident = false,
    isHashtag = true,
    hashtag = "",
    place = "",
    text = "Yesterday with @KarenMiller and @MarvinStemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!",
    mediaType = 1
    // link = "someHashtag"
}: MarkFeedPostProps) => {
    return (
        <div className="card is-post mb-20 mt-20">
            {/* <!-- Main wrap --> */}
            <div className={`content-wrap`}>
                {/* <!-- Post header --> */}
                <div className="post-mark d-flex flex-j-start">
                    <span>{isHashtag ? `#${hashtag}` : place}</span>
                </div>
                <div className="card-heading">
                    {/* <!-- User meta --> */}
                    <PostUserBlock />
                    {/* Right side dropdown */}
                    <FeedPostDropDown />
                </div>
                {/* <!-- /Post header --> */}

                {/* <!-- Post body --> */}
                <div className="card-body">
                    {isIncident ? <IncidentLocation /> : ""}
                    {/* <!-- Post body text --> */}
                    <PostText text={text} />
                    {/* <!-- Featured image --> */}
                    {mediaType ? (
                        <>
                            {mediaType == 1 ? (
                                <PostMedia1 />
                            ) : mediaType == 2 ? (
                                <PostMedia2 />
                            ) : mediaType == 3 ? (
                                <PostMedia3 />
                            ) : mediaType == 4 ? (
                                <PostMedia4 />
                            ) : mediaType == 5 ? (
                                <PostMediaVid vid={vid} />
                            ) : mediaType == 6 ? (
                                <PostMedia6 />
                            ) : mediaType == 7 ? (
                                <PostImagePoll />
                            ) : mediaType == 8 ? (
                                <PostTextPoll />
                            ) : mediaType == 9 ? (
                                <PostLink />
                            ) : (
                                ""
                            )}
                        </>
                    ) : (
                        ""
                    )}

                    {/* <PostActions setOpenComments={setOpenComments} /> */}
                </div>
                {/* <!-- /Post body --> */}

                {/* <!-- Post footer --> */}
                <div className="card-footer">
                    {/* <!-- Post statistics --> */}
                    <SocialCount />
                </div>
                {/* <!-- /Post footer --> */}
                <div className="d-flex flex-j-end mb-20 pr-20">
                    <Link
                        to={
                            isHashtag
                                ? `/hashtag/${hashtag}`
                                : `/placedetails/${place}`
                        }
                        className="cursor-pointer blue-text ml-auto"
                        // onClick={() => setShowThreads(true)}
                    >
                        View More
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default MarkFeedPost;
